export const OVERTIME_SECTION_KEYS = {
  requestDetails: 'overtime_approval_request_details',
  lineManager: 'overtime_approval_line_manager',
  financeConfirmation: 'overtime_approval_finance_confirmation',
} as const;

// TEMPORARY: Overtime Approval backend permissions are not ready yet.
export const DUMMY_OVERTIME_WORKFLOW_ID = 'dummy-overtime-request';

export const OVERTIME_SECTION_TITLES = {
  requestDetails: 'Request Details',
  lineManager: 'Line Manager Approval',
  financeConfirmation: 'Finance Confirmation',
} as const;

export const OVERTIME_GROUP_TITLES = {
  employeeDetails: 'Employee Details',
} as const;

export const OVERTIME_FIELD_LABELS = {
  employeeName: 'Employee Name',
  jobTitle: 'Job Title',
  department: 'Department',
  roleType: 'Role Type',
  employeeNumber: 'Employee Number',
  standardWorkingHours: 'Standard Working Hours',
  lineManager: 'Line Manager/Partner',
  overtimePolicy: 'Overtime Policy',
  overtimeWorked: 'Overtime Worked',
  matter: 'Matter',
  matterNumber: 'Matter Number',
  confirmApproval: 'Confirm Approval Overtime Request',
  comments: 'Comments',
  confirmation: 'Confirmation',
} as const;

export const OVERTIME_GRID_COLUMN_LABELS = {
  date: 'Date',
  day: 'Day',
  fromTime: 'From Time',
  toTime: 'To Time',
  hours: 'Hours',
  matterNumber: 'Matter Number',
  reason: 'Reason',
} as const;

export const YES_NO_OPTIONS = [
  { value: 'yes', label: 'Yes', disabled: false },
  { value: 'no', label: 'No', disabled: false },
] as const;

/** API schema does not provide option lists for these dropdowns. */
export const EMPTY_SELECT_OPTIONS: { value: string; label: string; disabled: boolean }[] =
  [];

export const OVERTIME_POLICY_TEXT = `Overtime Policy:
Secretaries and Business Services employees working client chargeable overtime should include a matter number and fee earner's initials for each instance of overtime. Please submit completed Overtime forms to HR Services within one week of completing the overtime to ensure that clients are recharged in a timely manner.


Paralegals should record all overtime on Aderant, and additionally complete this form, including a matter number and fee earner's initials for each instance of overtime. Please submit completed Overtime forms to HR Services by the last working day of the month for payment on the next month's pay day.


All other employees working overtime which is not chargeable to a client should send completed Overtime forms to HR Services by the last working day of the month for payment on the next month's pay day.


Please copy and paste the following url into your browser to access the full overtime policy:
http://sp2013/Support/Talent/Talent/Overtime Policy.DOCX`;
